<div class="flex items-center gap-1">
  <p-checkbox [ngModel]="value" (onChange)="onModelChange($event)" [binary]="true" />
  <label for="ny" class="ml-2">{{ label() }}</label>
</div>
